// Accept SDK messages only from trusted Pi origins.
export function setupPiMessageBridge(onMessage) {
  const isSandbox = String(process.env.REACT_APP_PI_SANDBOX).toLowerCase() === 'true';

  // Known origins used by Pi SDK
  const allowedOrigins = new Set([
    // Testnet / Sandbox
    'https://sandbox.minepi.com',
    // Mainnet
    'https://minepi.com',
    // CDN sometimes used by SDK assets (seen in your logs)
    'https://app-cdn.minepi.com',
  ]);

  // In testnet runs, we *must* accept sandbox origin.
  // In mainnet runs, SDK messages usually come from minepi.com (keep both allowed to be safe).

  function handler(event) {
    if (!allowedOrigins.has(event.origin)) {
      // Keep your debug log, but don't block legit sandbox traffic by mistake
      console.log('Discarding message - origin:', event.origin, '- data:', event.data);
      return;
    }
    try {
      onMessage?.(event);
    } catch (e) {
      console.error('Pi bridge message handler error:', e);
    }
  }

  window.addEventListener('message', handler);
  console.log(
    '[PiBridge] Initialized | sandbox =',
    isSandbox,
    '| allowedOrigins =',
    Array.from(allowedOrigins).join(', ')
  );

  return () => window.removeEventListener('message', handler);
}
